<div class="content-with-filled-button">
    <p class="sub-title">Ingresa la información de los créditos del cliente.</p>
    <vcl-button id="button-contextual-resend" class="border"
      label="Agregar información de crédito" (click)="addCredit()"
      buttonType="contextual"  [disableRipple]="true" [disabled]="flag">
    </vcl-button>
    <vcl-list>
        <li class="credit" *ngFor="let credits of creditList; let indexOfElement=index;" vclListSimple>
          <vcl-list-text>
            <p class="titulo">
                {{credits.type}} {{credits.number}}
            </p>
            <p class="amount">
                Saldo $ {{credits.amount | number}}
            </p>
          </vcl-list-text>
          <a (click)="editCredit(indexOfElement)">
            <voxel-icon class="icon">editar_outline</voxel-icon>
          </a>
        </li>
    </vcl-list>
</div>
<app-controls 
  id="docIntroBtns"
  [hasPrevious]="true"
  [nextLabel]="copyService.copies.metodo_desembolso_next_button"
  (next)="next()"
  [nextDisabled]="creditList.length === 0">
</app-controls>
